import { OAuth2AuthCodePKCE } from '@bity/oauth2-auth-code-pkce'
import { Record as ImmutableRecord } from 'immutable'
import { SessionAction, SessionActions } from 'lib/actions/session'
import { AccessContext } from 'lib/oauth'
import { initialGetReturn } from 'lib/rpc'

export class SessionState extends ImmutableRecord({
    item: initialGetReturn<AccessContext>(),
    client: null as OAuth2AuthCodePKCE | null,
}) {}

export const initialSessionState: SessionState = new SessionState()

export const sessionReducer = (state: SessionState, action: SessionActions): SessionState => {
    switch (action.type) {
        case SessionAction.load:
            return state.set('client', action.client).set('item', action.payload)
        // no default
    }
}
